import React from "react"
import 'pro-gallery/dist/statics/main.css';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your 
import ReactDOMServer from 'react-dom/server';
import Gallery from './Gallery'
import Picture from '../Picture'

export default function GalleryPage({ imagesQueryResult }) {
  const items = imagesQueryResult.allFile.edges.map((edge, index) => {
    const fullImageData = edge.node.childrenImageSharp[0].gatsbyImageData
    const imageName = edge.node.name;
    return {
      itemId: `portfolioImage${index}`,
      html: ReactDOMServer.renderToString(
        <Picture gatsbyImageData={edge.node.childImageSharp.gatsbyImageData} alt={imageName} />),
      fullUrl: fullImageData.images.fallback.src,
      placeholderUrl: fullImageData.images.fallback.src,
      metadata: {
        type: "text",
        height: edge.node.childImageSharp.gatsbyImageData.height / 2,
        width: edge.node.childImageSharp.gatsbyImageData.width / 2,
        title: imageName,
        description: imageName,
        backgroundColor: 'white'
      }
    }
  });

	return (
		<Gallery items={items}/>
	);
}
